import { render, staticRenderFns } from "./ButtonFavorite.vue?vue&type=template&id=f1855606&"
import script from "./ButtonFavorite.vue?vue&type=script&lang=js&"
export * from "./ButtonFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports